import { FacilityNurse } from "src/app/models/facility/facility-nurse";

export interface NursesState
{
    models: Record<string, FacilityNurse>;
    pagination: { pagesCount: number, page: number, limit: number };
    nurses: string[];
}

export const NURSES_FEATURE_KEY = 'nurses';